// extracted by mini-css-extract-plugin
export default {"thankYouMessage":"EvZv_c","errorMessage":"S5ZLov","errorIcon":"v4g6vX"};